/*
 * @Author: bobo 350910378@qq.com
 * @Date: 2022-04-07 15:43:33
 * @LastEditors: bobo 350910378@qq.com
 * @LastEditTime: 2024-11-21 21:03:11
 * @FilePath: \baishu_react_ui\src\components\BsyDept\index.jsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */

import React from "react";
import "./index.css";
import { BsyWidget } from "../BsyWidget";
import { BsyUtils } from "../../utils/Utils";
import _ from "lodash";
import { BsyConfig } from "../../global/BsyConfig";

export default class BsyDept extends BsyWidget {
  static defaultProps = {
    baseCls: "bsy-dept",
    width: 350,
    height: 34,
    value: null,
    allowBlank: !0,
    noRepeat: !1,
    editable: !1,
    count: 100,
    limit: [],
    type: "dept",
    dynamicType: "select",
    onStopEdit: null,
    onRelyLimit: null,
  };

  constructor(props) {
    super({
      type: "dept",
      ...props,
    });

    BsyUtils._initDeptMap(props.items);
    window.deptSelectMap = window.deptSelectMap || {};

    this.state = {
      title: React.language("widget.dept.listTitle"),
      msg: React.language("widget.dept.clickToSelect1"),
      waterMark: React.language("content.empty"),
      dynamicEnable: !0,
      dynamicFields: [
        {
          _id: BsyConfig().CONST.DEPT_ID.CURRENT,
          name: React.language("dept.current"),
          type: "department",
        },
        {
          _id: BsyConfig().CONST.DEPT_ID.CURRENT_PARDEPTS,
          name: "获取当前用户的上级部门", //React.language("dept.current"),
          type: "department",
        },
      ],
      dynamicKey: BsyConfig().CONST.DEPT_ID.CURRENT,
      ...props,
      value: this.getValueId(props.value),
    };

    this.value = this.state.value;
    this.current_departments();
  }

  _getDynamicFields = () => {
    return this.options.dynamicFields;
  };

  listMemberName = (value) => {
    const { ftoken } = this.state;
    if (ftoken) {
      return;
    }
    let that = this;
    if (BsyUtils.isObjectEmpty(value)) {
      return;
    }

    if (window.deptSelectMap[value]) {
      that.setState({});
      return;
    }

    React.axios("/corp/list_member_name", {
      members: value,
    })
      .then((res) => {
        let a = res.data;
        let d = [];
        if (a.virtually && a.virtually.length > 0) {
          BsyUtils.forEach(a.virtually, function (k, z) {
            switch (z.mode) {
              case "role":
                a.roles || (a.roles = []);
                a.roles.push(z);
                break;
              case "outsider":
                a.outsiderMember || (a.outsiderMember = []);
                a.outsiderMember.push(z);
                break;
              case "member":
                a.users || (a.users = []);
                a.users.push(z);
                break;
              case "outsiderGroup":
                a.outsiderGroup || (a.outsiderGroup = []);
                a.outsiderGroup.push(z);
                break;
              case "current":
              case "currentSub":
                a.job_title || (a.job_title = []);
                a.job_title.push(z);
                break;
              case "relationUser":
                a.userRelation || (a.userRelation = []);
                a.userRelation.push(z);
                break;
              case "relationDept":
                a.deptRelation || (a.deptRelation = []);
                a.deptRelation.push(z);
                break;
              case "deptSub":
              case "dept":
                a.departments || (a.departments = []);
                a.departments.push(z);
            }
          });
        }
        BsyUtils.forEach(a.departments, function (a, b) {
          d.push({
            _id: b._id,
            name: b.name,
            mode: b.mode,
            dept_path: b.dept_path,
            dept_corp: b.dept_corp,
            status: b.status || "",
            type: "departments",
          });
        });
        BsyUtils.forEach(a.dockcorp, function (a, b) {
          d.push({
            _id: b._id,
            name: b.name,
            mode: b.mode,
            dept_path: b.dept_path,
            dept_corp: b.dept_corp,
            status: b.status || "",
            type: "dockcorp",
          });
        });
        BsyUtils.forEach(a.dockuser, function (a, b) {
          d.push({
            _id: b._id,
            name: b.name,
            mode: b.mode,
            dept_path: b.dept_path,
            dept_corp: b.dept_corp,
            status: b.status || "",
            type: "dockuser",
          });
        });
        BsyUtils.forEach(a.dockrole, function (a, b) {
          d.push({
            _id: b._id,
            name: b.name,
            mode: b.mode,
            dept_path: b.dept_path,
            dept_corp: b.dept_corp,
            status: b.status || "",
            type: "dockrole",
          });
        });
        BsyUtils.forEach(a.dockdept, function (a, b) {
          d.push({
            _id: b._id,
            name: b.name,
            mode: b.mode,
            dept_path: b.dept_path,
            dept_corp: b.dept_corp,
            status: b.status || "",
            type: "dockdept",
          });
        });
        BsyUtils.forEach(a.outsiderGroup, function (a, b) {
          d.push({
            _id: b._id,
            name: b.name,
            mode: b.mode,
            dept_path: b.dept_path,
            dept_corp: b.dept_corp,
            status: b.status || "",
            type: "outsiderGroup",
          });
        });
        let items = d;//.concat(that._getDynamicFields());
        BsyUtils.forEach(items, function (t, i) {
          i && (window.deptSelectMap[i._id] = i);
        });
        that.setState({});
      })
      .catch((res) => {
        console.error(res);
      });
  };

  setLimit = (limit) => {
    this.options.limit = limit;
  };

  onClick = () => {
    var a = this,
      b = this.options;
    var c = new window.FX.ConfirmDialog({
      title: React.language("widget.dept.listTitle"),
      height: 588,
      width: 956,
      contentWidget: {
        rowSize: [451],
        colSize: [926],
        padding: 15,
        items: [
          [
            {
              widgetName: b.name || b.widgetName,
              rowIdx: b.rowIdx,
              type: b.type,
              
              editable: !0,
              limit: b.limit,
              rely: b.rely,
              items: a.items,
              value: a.value,
              onRelyLimit: b.onRelyLimit,
              valueOption: b.valueOption,
              noItemTips: !0,
              appId: b.appId,
              formId: b.formId,
              entryId: b.entryId,
              is_dock_form: b.is_dock_form,
            },
          ],
        ],
      },
      onCustmElement: function (element) {
        if (b.type === "deptgroup") {
          window
            .$('<div class="clean-select" />')
            .append('<i className="icon-bsy-clean" />')
            .append("<span >" + React.language("clean.select.item") + "</span>")
            .on("click", function (e) {
              var d = c.getWidgetByName(b.name || b.widgetName);
              window.FX.Utils.forEach(
                d.$selectList.find(".select-item"),
                function (a1, b1) {
                  var dd = window.$(b1).data("item");
                  if (dd) {
                    d._removeSelectItem(dd);
                  }
                }
              );
              d.refresh();
            })
            .appendTo(element);
        }
      },
      onClose: function () {
        BsyUtils.applyFunc(a, b.onClose, [a.value], !1);
      },
      onOk: function () {
        var d = c.getWidgetByName(b.name || b.widgetName);
        a.value = d.getValue();
        a.items = d.getItems();
        window.deptSelectMap = { ...window.deptSelectMap, ...d.selectMap };
        var info = null;
        if (a.options.type == "dept") {
          if (window.deptSelectMap[a.value]) {
            info = window.deptSelectMap[a.value];
          }
        } else {
          if (!BsyUtils.isObjectEmpty(a.value)) {
            info = [];
            for (var i = 0; i < a.value.length; i++) {
              var id = a.value[i];
              if (window.deptSelectMap[id]) {
                window.deptSelectMap[id].name = window.deptSelectMap[
                  id
                ].name.replace(" " + React.language("deling"), "");
                info.push(window.deptSelectMap[id]);
              }
            }
          }
        }
        a.setState(
          {
            value: a.value,
          },
          () => {
            BsyUtils.applyFunc(a, b.onStopEdit, [a.value, info, a], !1);
          }
        );

        return !1;
      },
    });
    c.show();
  };

  current_departments = () => {
    return;
  };

  getValue = () => {
    return this.value;
  };

  checkValidate = () => {
    const { ftoken } = this.state;
    this.setInvalidateTypeText("");
    if (ftoken) {
      this.setInvalidateTypeText(React.language("form.item.error.format"));
      return !1;
    }
    var a = this.options;
    return !BsyUtils.isObjectEmpty(this.getValue()) || a.allowBlank;
  };

  getDeptId = (ids) => {
    var id = [];
    if (ids) {
      for (let index = 0; index < ids.length; index++) {
        const element = ids[index];
        let sid = element._id || element.id;
        window.deptSelectMap[sid] = element;
        if (sid && id.indexOf(sid) == -1) id.push(sid);
      }
    }
    return id;
  };

  getValueId = (a) => {
    window.deptSelectMap = window.deptSelectMap || {};
    let that = this;
    const { is_dock_form } = this.options;
    let ftoken = window.FX.STATIC.FTOKEN;
    if (ftoken) {
      if (this.options.type == "dept") {
        if (!a) {
          return (this.value = null);
        }
        if (a.hasOwnProperty("_id") || a.hasOwnProperty("id")) {
          that.value = a._id || a.id;
        } else {
          that.value = a;
        }
        if (BsyConfig().CONST.DEPT_ID.CURRENT == a) {
          that.value = null;
        }
        if (BsyConfig().CONST.DEPT_ID.CURRENT_PARDEPTS == a) {
          that.value = null;
        }
      } else {
        if (Array.isArray(a)) {
          let val = [];
          let requestValue = [];
          for (let i = 0; i < a.length; i++) {
            var a1 = a[i];
            if (a1) {
              let id = _.get(a1, "id", null) || _.get(a1, "_id", null);
              if (id && BsyUtils.isString(id)) {
                if (id == BsyConfig().CONST.DEPT_ID.CURRENT) {
                } else if (
                  id == BsyConfig().CONST.DEPT_ID.CURRENT_SUBDEPT
                ) {
                } else {
                  window.deptSelectMap[id] = a1;
                  val.push(id);
                }
              } else {
                val.push(a1);
                requestValue.push(a1);
              }
            }
            // that.value = val;
          }
          if (requestValue.length) {
            that.listMemberName(requestValue);
          }
        }
      }
      return that.value;
    }

    window.CURRENTDEPTMAP = window.CURRENTDEPTMAP || {};
    if (is_dock_form) {
      window.CURRENTDEPTMAP[BsyConfig().CONST.DEPT_ID.CURRENT] =
        window.localDevInfo.user.dock_current_departments || window.localDevInfo.user.current_departments;
    } else {
      window.CURRENTDEPTMAP[BsyConfig().CONST.DEPT_ID.CURRENT] =
        window.CURRENTDEPTMAP[BsyConfig().CONST.DEPT_ID.CURRENT] ||
        window.localDevInfo.user.current_departments;
    }
    if (this.options.type == "dept") {
      if (!a) {
        return (this.value = null);
      }

      if (a.hasOwnProperty("_id") || a.hasOwnProperty("id")) {
        this.value = a._id || a.id;
        window.deptSelectMap[this.value] = a;
      } else {
        this.value = a;
      }

      if (BsyConfig().CONST.DEPT_ID.CURRENT_PARDEPTS == that.value) {
        that.value = null;

        let cacheKey = [
          that.options.deptLevel,
          that.options.deptLevelLimit,
        ].join("--");
        if (window.deptSelectMap[cacheKey]) {
          that.value =
            window.deptSelectMap[cacheKey]._id ||
            window.deptSelectMap[cacheKey].id;
          if (that.value) {
            return that.value;
          }
        }

        window.FX.Utils.dataAjax(
          {
            url: "/data/member/current_departments",
            data: {
              appId: window.FX.STATIC.APPID || that.options.appId,
              deptLevel: that.options.deptLevel,
              deptLevelLimit: that.options.deptLevelLimit,
            },
            async: !1,
          },
          function (c1) {
            if (c1.departmentList.length) {
              BsyUtils.forEach(c1.departmentList, function (a1, b1) {
                window.deptSelectMap[b1._id] = b1;
                window.deptSelectMap[cacheKey] = b1;
                that.value = b1._id;
              });
            }
          }
        );
        return this.value;
      }

      if (BsyConfig().CONST.DEPT_ID.CURRENT == this.value) {
        if (
          window.CURRENTDEPTMAP[BsyConfig().CONST.DEPT_ID.CURRENT].length
        ) {
          this.value =
            window.CURRENTDEPTMAP[
              BsyConfig().CONST.DEPT_ID.CURRENT
            ][0]._id;
          window.deptSelectMap[this.value] =
            window.CURRENTDEPTMAP[BsyConfig().CONST.DEPT_ID.CURRENT][0];
        } else {
          return (this.value = null);
        }
      }

      if (this.value && !window.deptSelectMap[this.value]) {
        that.listMemberName([this.value]);
      }
      return this.value;
    }
    if (is_dock_form) {
      window.CURRENTDEPTMAP[BsyConfig().CONST.DEPT_ID.CURRENT_SUBDEPT] =
        window.localDevInfo.user.dock_current_sub_departments;
    } else {
      window.CURRENTDEPTMAP[BsyConfig().CONST.DEPT_ID.CURRENT_SUBDEPT] =
        window.CURRENTDEPTMAP[BsyConfig().CONST.DEPT_ID.CURRENT_SUBDEPT] ||
        window.localDevInfo.user.current_sub_departments;
    }
    let val = [];
    let requestValue = [];
    if (Array.isArray(a)) {
      for (let i = 0; i < a.length; i++) {
        let a1 = a[i];
        if (a1) {
          let id = _.get(a1, "id", null) || _.get(a1, "_id", null);
          if (id && BsyUtils.isString(id)) {
            if (id == BsyConfig().CONST.DEPT_ID.CURRENT) {
              val = val.concat(
                this.getDeptId(
                  window.CURRENTDEPTMAP[BsyConfig().CONST.DEPT_ID.CURRENT]
                )
              );
            } else if (id == BsyConfig().CONST.DEPT_ID.CURRENT_SUBDEPT) {
              val = val.concat(
                this.getDeptId(
                  window.CURRENTDEPTMAP[
                  BsyConfig().CONST.DEPT_ID.CURRENT_SUBDEPT
                  ]
                )
              );
            } else {
              if (!window.deptSelectMap[id]) {
                window.deptSelectMap[id] = a1;
              }
              val.push(id);
            }
          } else {
            if (a1 == BsyConfig().CONST.DEPT_ID.CURRENT) {
              val = val.concat(
                this.getDeptId(
                  window.CURRENTDEPTMAP[BsyConfig().CONST.DEPT_ID.CURRENT]
                )
              );
            } else if (a1 == BsyConfig().CONST.DEPT_ID.CURRENT_SUBDEPT) {
              val = val.concat(
                this.getDeptId(
                  window.CURRENTDEPTMAP[
                  BsyConfig().CONST.DEPT_ID.CURRENT_SUBDEPT
                  ]
                )
              );
            } else {
              if (!window.deptSelectMap[a1]) {
                // window.deptSelectMap[a1] = a1;
                requestValue.push(a1);
              }
              val.push(a1);
            }
          }
        }
      }
    }
    if (requestValue && requestValue.length) {
      that.listMemberName(requestValue);
    }
    return BsyUtils.arrayUnique(val);
  };

  setValue = (val) => {
    if (val) {
      if (BsyUtils.isObjectEmpty(val)) {
        val = null;
      }
    }
    this.value = this.getValueId(val);
    this.setState(
      {
        value: this.value,
      },
      () => {
        this.listMemberName();
      }
    );
  };

  renderBody = () => {
    const { value, islinkQuery, ftoken, msg } = this.state;
    if (ftoken && !islinkQuery) {
      return (
        <div className="nonsupport-msg">
          {React.language("outlink.tip.dept")}
        </div>
      );
    } else {
      let item = window.deptSelectMap[value];
      if (BsyUtils.isObjectEmpty(item)) {
        item = { id: value };
      }
      return (
        <ul className="select-list" onClick={this.onClick}>
          {value && item ? (
            <li className="select-item" id={value}>
              <i
                className={`select-icon ${item.type === "outsiderGroup" || item.mode === "outsider"
                  ? "icon-outsider-group"
                  : item.type === "dockcorp"
                    ? "icon-bby-iconqiyeshezhi"
                    : "icon-department"
                  }`}
              ></i>
              {/*{item.type === "dockdept" && !!item.dept_corp && <span style={{margin: '0 2px 0 0'}}>{item.dept_corp + " - "}</span>}*/}
              <span className={item.status === -99 ? "deleted" : ""}>
                {item.name || item.nickname || value}
              </span>
              {/*{item.type === "dockcorp" && <span style={{color: '#999','margin-left': '6px','font-size': '14px'}}>({React.language('contact.docking.people')})</span>}*/}
            </li>
          ) : (
            <div className="select-empty">{msg}</div>
          )}
        </ul>
      );
    }
  };

  renderDisablePane = () => {
    const { value, islinkQuery, ftoken, appId, is_dock_form } = this.state;
    let item = null;
    if (value) {
      item = window.deptSelectMap[value];
    }
    let text = BsyUtils._toDeptUser(item);
    if (ftoken && !islinkQuery) {
      return (
        <div className="nonsupport-msg">
          {React.language("outlink.tip.user")}
        </div>
      );
    }
    if (BsyUtils.isObjectEmpty(item)) {
      return (
        <div
          className="bsy_form_item_disable bsy-select-dept"
          data-watermark={React.language("content.empty")}
        ></div>
      );
    }

    return (
      <div
        className="bsy_form_item_disable bsy-select-dept"
        data-watermark={React.language("content.empty")}
      >
        <ul className="select-list">
          {value && item ? (
            <li
              className="select-item"
              id={value}
              onClick={(e) => {
                BsyUtils.showUserInfo(item, null, e, appId, is_dock_form);
              }}
            >
              <i
                className={`select-icon ${item.type === "outsiderGroup" || item.mode === "outsider"
                  ? "icon-outsider-group"
                  : item.type === "dockcorp"
                    ? "icon-bby-iconqiyeshezhi"
                    : "icon-department"
                  }`}
              ></i>
              {/*{item.type === "dockdept" && !!item.dept_corp && <span style={{margin: '0 2px 0 0'}}>{item.dept_corp + " - "}</span>}*/}
              <span className={item.status === -99 ? "deleted" : ""}>
                {text}
              </span>
              {/*{item.type === "dockcorp" && <span style={{color: '#999','margin-left': '6px','font-size': '14px'}}>({React.language('contact.docking.people')})</span>}*/}
            </li>
          ) : (
            ""
          )}
        </ul>
      </div>
    );
  };

  render() {
    const { cssName, css } = this.options;

    if (!this.isEnabled()) {
      return this.renderDisablePane();
    }

    return (
      <div className={cssName} style={css} ref={this.element}>
        {this.renderBody()}
      </div>
    );
  }
}
